<template>
    <legacy-group-report-template v-model:current-report-template-id="currentReportTemplateId"
                           v-model:default-settings="$data._settings"
                           v-model:display-section="displaySection"
                           v-model:for-group="forGroup"
                           v-model:interval="$data._interval"
                           v-model:ran-report="$data._reportSuccessfullySent"
                           v-model:reload-data="$data._reloadTable"
                           v-model:running-errors="$data._errorSending"
                           v-model:running-report="$data._runningReport"
                           v-model:settings="$data._settings"
                           v-model:users="users"
                           :can-edit="permissions.can('manage_compliance_achievement_report')"
                           :default-settings="defaultSettings"
                           interval="monthly"

                           report-name="threshold-achievement-report"
                           @useStandardReporting="setUseStandardReporting"
    >
        <template #create-settings>
            <legacy-threshold-achievement-report-settings
                v-model:settings="$data._settings"
                :for-manual="false"
                :timezone="timezone"
            >
            </legacy-threshold-achievement-report-settings>
        </template>

        <template #edit-settings>
            <legacy-threshold-achievement-report-settings
                v-model:settings="$data._settings"
                :for-manual="false"
                :show-all="displaySection === 'show-template' || useStandardReporting"
                :timezone="timezone"
            >
            </legacy-threshold-achievement-report-settings>
        </template>

        <template #run-options>
            <legacy-threshold-achievement-report-settings
                v-model:endDate="$data._endDate"
                v-model:settings="$data._settings"
                v-model:startDate="$data._startDate"
                :max-date="maxDate"
                :min-date="minDate"
                :timezone="timezone"
                @run-report="runReport(currentReportTemplateId)"
            >
            </legacy-threshold-achievement-report-settings>
        </template>
    </legacy-group-report-template>
</template>

<script>
import axios from "axios"
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import ReportHomeModal from "@/components/GroupReports/Legacy/LegacyReportHomeModal.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import BaseReport from "@/components/Reports/BaseReport";
import MeterIntervalSelection from "@/components/GroupReports/Legacy/LegacyMeterIntervalSelection.vue";
import DetailedAlarmReportSettings from "@/components/GroupReports/Legacy/LegacyDetailedAlarmReportSettings.vue";
import AjaxTable from "@/components/elements/AjaxTable";
import Select2 from "@/components/elements/select2";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "@/components/GroupReports/Legacy/LegacyGroupReportTemplate.vue";
import ThresholdAchievementReportSettings from "@/components/GroupReports/Legacy/LegacyThresholdAchievementReportSettings.vue";

export default {
    name: "GroupThresholdAchievementReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        ThresholdAchievementReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        minDate: {
            type: String,
        },
        maxDate: {
            type: String,
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        users: {
            type: Object,
            default() {
                return {}
            }
        },
        startDate: {
            type: String,
            default: null
        },
        timezone: {
            type: String,
            default: 'America/New_York',
        },
    },
    data() {
        return {
            displaySection: null,

            _templateName: '',
            _groupId: null,

            _data: [],

            _reloadTable: false,
            _settings: this.defaultSettings,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,

            useStandardReporting: false,

            _startDate: this.startDate,
            _endDate: null,

            _interval: this.interval,
            endOfInterval: new Date(),
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }

            params['end'] = this.$data._endDate
            params['start'] = this.$data._startDate
            params['pass_threshold'] = this.$data._settings['passThreshold']

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/threshold-achievement-report'), params)
                .then(response => {
                    let data = response.data
                    console.log(`Report Queued successfully, data is`)
                    console.log(data)
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    let data = response.data
                    console.log(`Report Queued Failed, data is`)
                    console.log(data)
                    // Store the logs from errors to show.
                    this.$data._errorSending = data
                })
                .finally(() => {
                    console.log(`Report finalizing`)
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        }
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>